export const featurePaths = {
  TransactionList: "/transactionlist",
  PaymentDetails: "/paymentdetails",
};
